import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MutualFundInvestingService } from '../../../mutual-fund-investing/mutual-fund-investing.service';
import { InstructionNotificationModel } from './instruction-notification-model';
import { messageConstants } from '../../../shared/constants';

@Component({
    selector: 'instruction-notification',
    templateUrl: './instruction-notification.component.html',
    styleUrls: ['./instruction-notification.component.scss']
})
export class InstructionNotificationComponent implements OnInit, OnDestroy {
  notificationType: string;

  showNotification: boolean;

  notificationMessages = [];

  notificationSub: Subscription;

  notificationHeading: string;

  notificationBold: string;

  isHardEdit: boolean = false;

  isInstructionAlreadyExistsWarning: boolean = false;

  constructor(private mfInvestingService: MutualFundInvestingService) {}

  ngOnInit(): void {
    this.mfInvestingService.instructionNotification$.subscribe((data) => this.populateNotification(data));
    this.mfInvestingService.clearHardEditNotification$.subscribe(() => this.clearHardEditNotification());
    this.mfInvestingService.clearInstructionAlreadyExistsNotification$.subscribe(() =>
      this.clearInstructionAlreadyExistsNotification()
    );
  }

  ngOnDestroy(): void {
    if (this.notificationSub) {
      this.notificationSub.unsubscribe();
    }
  }

  isNoTradeDataAccessNotificationActive(): boolean {
    if (this.notificationMessages.includes(messageConstants.noTradeDataAccessMessage)) {
      return true;
    }

    return false;
  }

  clearNotification(): void {
    this.showNotification = false;
    this.notificationType = null;
    this.notificationHeading = null;
    this.notificationBold = null;
    this.notificationMessages = [];
    this.isHardEdit = false;
    this.isInstructionAlreadyExistsWarning = false;
  }

  clearHardEditNotification(): void {
    if (this.isHardEdit) {
      this.showNotification = false;
      this.notificationType = null;
      this.notificationMessages = [];
      this.isHardEdit = false;
    }
  }

  clearInstructionAlreadyExistsNotification(): void {
    if (this.isInstructionAlreadyExistsWarning) {
      this.showNotification = false;
      this.notificationType = null;
      this.notificationMessages = [];
      this.isInstructionAlreadyExistsWarning = false;
    }
  }

  populateNotification(data: InstructionNotificationModel): void {
    if (data) {
      this.showNotification = true;
      this.notificationType = data.notificationType;
      this.notificationMessages = data.messages;
      this.notificationHeading = data.notificationHeading;
      this.notificationBold = data.notificationBold;
      this.isHardEdit = data.isHardEdit ?? false;
      this.isInstructionAlreadyExistsWarning = data.isInstructionAlreadyExistsWarning ?? false;
    } else {
      this.showNotification = false;
      this.notificationType = null;
      this.notificationHeading = null;
      this.notificationBold = null;
      this.notificationMessages = [];
      this.isHardEdit = false;
      this.isInstructionAlreadyExistsWarning = false;
    }
  }
}
